export const isIgnoredPathForOneTrustScriptInjection = (path = '') => {
    const IGNORED_PATHS = ['/cookies', '/terms-and-conditions'];
    return IGNORED_PATHS.some(ignoredPath => new RegExp(`^${ignoredPath}/?$`).test(path));
};
